import React from 'react'
import WalletPageComponent from '../components/wallet'

function WalletPage() {
  return (
    <div className='px-4'><WalletPageComponent/></div>
  )
}

export default WalletPage